export default __webpack_public_path__ + "static/uqSWQnoP-7bad28dad3711d63e45110119512a04f.svg";